import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function MenuOpen({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <MenuOpen.Outline {...props} />
  ) : (
    <MenuOpen.Solid {...props} />
  );
}

MenuOpen.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <path
        fill="currentColor"
        d="M1.36425 20.0781H16.3711C17.1214 20.0781 17.7353 19.4781 17.7353 18.7448C17.7353 18.0115 17.1214 17.4115 16.3711 17.4115H1.36425C0.613915 17.4115 0 18.0115 0 18.7448C0 19.4781 0.613915 20.0781 1.36425 20.0781ZM1.36425 13.4115H12.2783C13.0286 13.4115 13.6425 12.8115 13.6425 12.0781C13.6425 11.3448 13.0286 10.7448 12.2783 10.7448H1.36425C0.613915 10.7448 0 11.3448 0 12.0781C0 12.8115 0.613915 13.4115 1.36425 13.4115ZM0 5.41146C0 6.14479 0.613915 6.74479 1.36425 6.74479H16.3711C17.1214 6.74479 17.7353 6.14479 17.7353 5.41146C17.7353 4.67813 17.1214 4.07812 16.3711 4.07812H1.36425C0.613915 4.07812 0 4.67813 0 5.41146ZM23.6016 15.9181L19.6726 12.0781L23.6016 8.23812C23.7279 8.11468 23.8281 7.96813 23.8965 7.80685C23.9648 7.64556 24 7.4727 24 7.29813C24 7.12355 23.9648 6.95069 23.8965 6.7894C23.8281 6.62812 23.7279 6.48157 23.6016 6.35813C23.4753 6.23468 23.3254 6.13676 23.1603 6.06996C22.9953 6.00315 22.8184 5.96876 22.6398 5.96876C22.4612 5.96876 22.2843 6.00315 22.1193 6.06996C21.9543 6.13676 21.8043 6.23468 21.678 6.35813L16.7803 11.1448C16.6539 11.2681 16.5535 11.4147 16.4851 11.576C16.4166 11.7373 16.3814 11.9102 16.3814 12.0848C16.3814 12.2594 16.4166 12.4323 16.4851 12.5936C16.5535 12.7549 16.6539 12.9014 16.7803 13.0248L21.678 17.8115C22.2101 18.3315 23.0695 18.3315 23.6016 17.8115C24.12 17.2915 24.1337 16.4381 23.6016 15.9181Z"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

MenuOpen.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <path
        fill="currentColor"
        d="M1.36425 20.0781H16.3711C17.1214 20.0781 17.7353 19.4781 17.7353 18.7448C17.7353 18.0115 17.1214 17.4115 16.3711 17.4115H1.36425C0.613915 17.4115 0 18.0115 0 18.7448C0 19.4781 0.613915 20.0781 1.36425 20.0781ZM1.36425 13.4115H12.2783C13.0286 13.4115 13.6425 12.8115 13.6425 12.0781C13.6425 11.3448 13.0286 10.7448 12.2783 10.7448H1.36425C0.613915 10.7448 0 11.3448 0 12.0781C0 12.8115 0.613915 13.4115 1.36425 13.4115ZM0 5.41146C0 6.14479 0.613915 6.74479 1.36425 6.74479H16.3711C17.1214 6.74479 17.7353 6.14479 17.7353 5.41146C17.7353 4.67813 17.1214 4.07812 16.3711 4.07812H1.36425C0.613915 4.07812 0 4.67813 0 5.41146ZM23.6016 15.9181L19.6726 12.0781L23.6016 8.23812C23.7279 8.11468 23.8281 7.96813 23.8965 7.80685C23.9648 7.64556 24 7.4727 24 7.29813C24 7.12355 23.9648 6.95069 23.8965 6.7894C23.8281 6.62812 23.7279 6.48157 23.6016 6.35813C23.4753 6.23468 23.3254 6.13676 23.1603 6.06996C22.9953 6.00315 22.8184 5.96876 22.6398 5.96876C22.4612 5.96876 22.2843 6.00315 22.1193 6.06996C21.9543 6.13676 21.8043 6.23468 21.678 6.35813L16.7803 11.1448C16.6539 11.2681 16.5535 11.4147 16.4851 11.576C16.4166 11.7373 16.3814 11.9102 16.3814 12.0848C16.3814 12.2594 16.4166 12.4323 16.4851 12.5936C16.5535 12.7549 16.6539 12.9014 16.7803 13.0248L21.678 17.8115C22.2101 18.3315 23.0695 18.3315 23.6016 17.8115C24.12 17.2915 24.1337 16.4381 23.6016 15.9181Z"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
